module.exports = __webpack_public_path__ + "img/bh_11.a7a1ab49.jpg";